<!-- <p>asset-models works!</p> -->

<app-dialog-header headerIcon="auto_awesome" headerText="{{selectedAsset.Name}} - {{selectedAsset.Description}} Models"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
<div class="main-div">
    <div class="dropdown-div" *ngIf="modelTypes.length > 0">
        <ejs-dropdownlist id="dropdown" #dropdown [dataSource]='modelTypes' placeholder="Select a Model Type"
            [fields]="modelFields" [allowFiltering]="false" filterType="contains" (change)="modelTypeChange($event)">
            <ng-template #itemTemplate let-data>
                <div>
                    <span>{{ data.ModelName }}</span>
                </div>
            </ng-template>
        </ejs-dropdownlist>
    </div>
    <div class="alignColumn">
        <span class="section-title">Model Type Details</span>
    </div>
    <div class="model-details" *ngIf="selectedModelType">
        <span>Model Type Name:</span>
        <span>{{selectedModelType.ModelName}}</span>
        <span>Model Type Description:</span>
        <span>{{selectedModelType.ModelDescription}}</span>
        <span>Model Type Use:</span>
        <span style="font-weight: bolder;">{{selectedModelType.ModelUse}}</span>
    </div>
    <div class="alignColumn" *ngIf="!selectedModelType">
        <span>Select a Model Type from the dropdown menu to view its details.</span>
    </div>
    <div class="alignColumn" *ngIf="selectedModelType">
        <span class="section-title">Models of this Type</span>
    </div>
    <div class="model-details" style="grid-template-columns: 1fr 1fr;"
        *ngIf="selectedModelType && getListOfModels() as list">
        <span>Existing Models for this Asset:</span>
        <span style="font-weight: bolder;">{{list.length}}</span>
        <span *ngIf="list.length > 0">Active Models:</span>
        <span *ngIf="list.length > 0" style="font-weight: bolder;">{{(activeModels && activeModels.length > 0) ? activeModels.length : 'None'}}</span>
    </div>
    <div class="alignColumn" *ngIf="selectedModelType && getListOfModels().length > 0">
        <span class="section-title">Selected Model</span>
    </div>
    <div class="model-details" style="grid-template-columns: 1fr 1fr;"
        *ngIf="selectedModelType && getListOfModels().length > 0 && getListOfModels() as list">
        <span *ngIf="list.length > 0">Selected Model created:</span>
        <span *ngIf="list.length > 0" style="font-weight: bolder;">{{convertEpoch(selectedModel.CreatedAt)}}</span>
        <div style="display: grid; grid-template-columns: 1.25fr 0.75fr;">
            <span *ngIf="list.length > 0">Selected Model start point:</span>
            <span *ngIf="list.length > 0"
                style="font-weight: bolder;">{{getDateWithoutTime(selectedModel.StartPoint)}}</span>
        </div>
        <div style="display: grid; grid-template-columns: 1.25fr 0.75fr;">
            <span *ngIf="list.length > 0">Selected Model end point:</span>
            <span *ngIf="list.length > 0"
                style="font-weight: bolder;">{{getDateWithoutTime(selectedModel.EndPoint)}}</span>
        </div>
        <span *ngIf="list.length > 0">Selected Model type:</span>
        <span *ngIf="list.length > 0" style="font-weight: bolder;">{{selectedModel.IsAutomatic ? "Automatic" :
            "Manual"}}</span>
    </div>
    <div class="button-div alignColumn" style="grid-template-columns: 1fr 1fr 1fr 1fr 0.5fr;"
        *ngIf="selectedModelType && getListOfModels().length > 0">
        <button mat-raised-button color="primary" *ngIf="getListOfModels().length > 0"
            (click)="goToModel(selectedModel)">
            <span>View selected</span>
            <mat-icon>visibility</mat-icon>
        </button>
        <button mat-raised-button color="primary" *ngIf="getListOfModels().length > 0"
            (click)="recreateModel(selectedModel)">
            <span>Edit selected</span>
            <mat-icon>edit</mat-icon>
        </button>
        <button mat-raised-button color="primary" *ngIf="getListOfModels().length > 0"
            (click)="openTestDistributionWindow(selectedModel)">
            <span>Test selected</span>
            <mat-icon>science</mat-icon>
        </button>
        <button mat-raised-button
            *ngIf="getListOfModels().length > 0 && !selectedModel.Disabled && !selectedModel.MostRecent"
            (click)="patchOldDistribution(selectedModel, true, false)">
            <span>Activate</span>
            <mat-icon>check></mat-icon>
        </button>
        <button mat-raised-button
            *ngIf="getListOfModels().length > 0 && !selectedModel.Disabled && selectedModel.MostRecent"
            (click)="patchOldDistribution(selectedModel, false, false)">
            <span>Deactivate</span>
            <mat-icon>close></mat-icon>
        </button>
        <button mat-raised-button *ngIf="getListOfModels().length > 0 && !selectedModel.Disabled"
            (click)="patchOldDistribution(selectedModel, false, true)">
            <span>Delete</span>
            <mat-icon style="color: salmon;">delete></mat-icon>
        </button>
        <!-- <button mat-raised-button *ngIf="getListOfModels().length > 0 && selectedModel.Disabled"
            (click)="patchOldDistribution(selectedModel, false, false)">
            <span>Enable</span>
            <mat-icon>do_not_disturb_off></mat-icon>
        </button> -->
    </div>
    <div class="button-div" *ngIf="selectedModelType">
        <button mat-raised-button (click)="createNewModel()">
            <span>Create new Model of this Type</span>
            <mat-icon>add</mat-icon>
        </button>
    </div>

    <div class="accordion-div" *ngIf="getListOfModels().length > 1 && otherModels as list">
        <ejs-accordion style="margin-top: 1em; border-radius: var(--default-border-radius);">
            <e-accordionitems>
                <e-accordionitem>
                    <ng-template #header>
                        <div><u>All Models ({{list.length}})</u></div>
                    </ng-template>
                    <ng-template #content>
                        <div class="list-headings">
                            <span>Created At</span>
                            <span>Type</span>
                            <span>Start Point</span>
                            <span>End Point</span>
                            <span>View</span>
                            <span>Test</span>
                            <span></span>
                            <span></span>
                        </div>
                        <ejs-listbox #listbox *ngIf="otherModels.length > 0" [dataSource]="otherModels"
                            [fields]="getFields()" class="listbox-container">
                            <ng-template #itemTemplate let-data>
                                <div class="ejs-listbox-item list-headings alignRow alignColumn"
                                    (click)="selectModel(data)" [ngStyle]="{'background-color': isSelectedModel(data) ? 'whitesmoke' : ''}">
                                    <span>{{convertEpoch(data.CreatedAt)}}</span>
                                    <span (click)="selectModel(data)">{{data.IsAutomatic ? "Automatic" :
                                        "Manual"}}</span>
                                    <span (click)="selectModel(data)">{{getDateWithoutTime(data.StartPoint)}}</span>
                                    <span (click)="selectModel(data)">{{getDateWithoutTime(data.EndPoint)}}</span>
                                    <button mat-icon-button style="justify-self: center;"
                                        (click)="goToModel(data)"><mat-icon>visibility</mat-icon></button>
                                    <button mat-icon-button style="justify-self: center;"
                                        (click)="openTestDistributionWindow(data)"><mat-icon>science</mat-icon></button>
                                    <button *ngIf="!data.MostRecent" mat-icon-button matTooltip="Activate" style="justify-self: center;"
                                        (click)="patchOldDistribution(data, true, false)"><mat-icon>check</mat-icon></button>
                                    <button *ngIf="data.MostRecent" mat-icon-button matTooltip="Deactivate"
                                        (click)="patchOldDistribution(data, false, false)"><mat-icon>close</mat-icon></button>
                                    <button mat-icon-button *ngIf="!data.Disabled" matTooltip="Delete"
                                        style="justify-self: center; color: salmon;"
                                        (click)="patchOldDistribution(data, false, true)"><mat-icon>delete</mat-icon></button>
                                    <!-- <button mat-icon-button *ngIf="data.Disabled" matTooltip="Enable" style="color: lightgreen;"
                                        (click)="patchOldDistribution(data, false, false)"><mat-icon>do_not_disturb_off</mat-icon></button> -->
                                </div>
                            </ng-template>
                        </ejs-listbox>
                    </ng-template>
                </e-accordionitem>
            </e-accordionitems>
        </ejs-accordion>
    </div>
</div>